/** True when value is null or undefined (not empty string). */
export function isNullOrUndefined(value: unknown): value is null | undefined {
	return value === null || value === undefined;
}
